import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProfileHeader from './ProfileHeader';
import ClosetWishlist from './ClosetWishlist';
import Lookbooks from './Lookbooks';
import PersonalCapsuleItem from './PersonalCapsuleItem';
import s from './ProfilePage.module.css';

const ProfilePage: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const gender = searchParams.get('gender') || '';
    const isSubscriber = searchParams.get('isSubscriber') === 'true';

    useEffect(() => {
        if (gender) {
            localStorage.setItem('userGender', gender);
        }

    }, [gender]);

    return (
        <div className={s.container}>
            <ProfileHeader />
            <div className={s.divider} />
            <Lookbooks />
            <div className={s.divider} />
            <ClosetWishlist />
            <div className={s.divider} />
            {isSubscriber && <PersonalCapsuleItem gender={gender} />}
        </div>
    );
};

export default ProfilePage;